import React from 'react';
import { createStyles, WithStyles, withStyles } from '@material-ui/core';

import { Box } from './Box';
import { BoxHeader } from './BoxHeader';
import { useTranslator } from '../i18n/useTranslator';

const styles = () => createStyles({});

type Props = WithStyles<typeof styles> & {};

const AuthorSubmissionInstructionsComponent: React.FunctionComponent<Props> = () => {
  const { t } = useTranslator();

  return (
    <Box>
      <BoxHeader title={t('instructions')} />
      <ol>
        <li>Pobierz szablony dokumentów i zapisz je u siebie na dysku</li>
        <li>Uzupełnij szablony</li>
        <li>Załącz do zgłoszenia skany wypełnionych dokumentów</li>
      </ol>
      <div>
        {t('iInCaseOfHelp')} <a href="mailto:fundacja@polpharma.com">fundacja@polpharma.com</a>
      </div>
    </Box>
  );
};

export const AuthorSubmissionInstructions = withStyles(styles)(AuthorSubmissionInstructionsComponent);
